// extracted by mini-css-extract-plugin
export default {"talent":"talent_talent__Mbcd0","btn4":"talent_btn4__8qs33"};